// AgentDashboard.js
import React from 'react';
import { FaUserTie, FaUsers, FaBriefcase, FaWallet, FaCrown } from 'react-icons/fa';

const AgenttDashboard = () => {
  const cards = [
    {
      title: 'Employers Created',
      value: 5,
      icon: <FaUserTie />,
      btn: 'View Employers',
    },
    {
      title: 'Jobseekers Created',
      value: 8,
      icon: <FaUsers />,
      btn: 'View Jobseekers',
    },
    {
      title: 'Jobs Posted',
      value: 3,
      icon: <FaBriefcase />,
      btn: 'View Jobs',
    },
    {
      title: 'Wallet Balance',
      value: '$150',
      icon: <FaWallet />,
      btn: 'Top Up Wallet',
    },
    {
      title: 'Subscription Plan',
      value: 'Premium',
      icon: <FaCrown />,
      btn: 'Manage Plan',
      endDate: 'Ends on: 30 June 2025',
    },
  ];

  return (
    <div>
      <h2 className="dashboard-title mb-4">Agent Dashboard</h2>
      <div className="row g-4 justify-content-center">
        {cards.map((card, i) => (
          <div className="col-md-4" key={i}>
            <div className="dashboard-card">
              <div className="icon-box">{card.icon}</div>
              <h5>{card.title}</h5>
              <p className="value">{card.value}</p>
              {card.endDate && <p className="subtext">{card.endDate}</p>}
              <button className="action-btn">{card.btn}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgenttDashboard;
